import { useGet } from './useFetch'
import { useAuth } from './useAuth'
import { ApiResponse } from '@magnetar/admin-api-interfaces'

/**
 * Read-only supplier view: list of ad-schedule templates that contain at
 * least one advertisement owned by the supplier. Matches the response of
 * `GET /api/ad-supplier/:supplier_id/ad-schedule-templates`.
 *
 * The list response is template metadata only (no slots). Use
 * `useSupplierAdSchedule` to fetch the detailed slot+item structure.
 */
export interface SupplierAdScheduleTemplateSummary {
  template_id: number
  template_name: string
  description?: string | null
  provider_id?: number | null
  is_active: boolean
  duration_limit_enabled: boolean
  created_at: string
  updated_at: string
}

interface UseSupplierAdSchedulesParams {
  supplierId: number | null | undefined
}

export function useSupplierAdSchedules({ supplierId }: UseSupplierAdSchedulesParams) {
  const { token } = useAuth()

  const url =
    token && supplierId ? `/api/ad-supplier/${supplierId}/ad-schedule-templates` : null

  const { data, error, mutate } = useGet<ApiResponse<SupplierAdScheduleTemplateSummary[]>>(
    url,
    undefined,
    token ?? '',
  )

  return {
    templates: data?.data ?? [],
    isLoading: !!url && !error && !data,
    isError: error,
    mutate,
  }
}
